
import Vue from 'vue'

export default Vue.extend({
  name: 'RStars',
  props: {
    name: {
      type: String,
      default: 'StarsInput',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Number,
    },
    max: {
      type: Number,
      default: 5,
    },
    char: {
      type: String,
      default: '★',
    },
    // Sometimes, you may want to use a different set of characters for the "active" values than the "inactive" ones.
    // This is especially useful for icon fonts such as FontAwesome that provide different glyphs for on/off state.
    inactiveChar: {
      type: String,
    },
  },

  methods: {
    getActiveLabel(x: number): string {
      const s = this.ratingChars
      return s[Math.min(s.length - 1, x - 1)]
    },
    getInactiveLabel(x: number): string {
      const s = this.inactiveRatingChars
      return s[Math.min(s.length - 1, x - 1)]
    },
    updateInput(v: string): void {
      this.$emit('input', parseInt(v, 10))
    },
  },

  computed: {
    classes(): {} {
      const { notouch, readonly } = this
      return {
        'stars-input': true,
        notouch,
        readonly,
      }
    },

    notouch(): boolean {
      /* For iPhone specifically but really any touch device, there is no true hover state, disables any pseudo-hover activity. */
      return typeof document !== 'undefined' && !('ontouchstart' in document.documentElement)
    },

    ratingChars(): string[] {
      return Array.from(this.char)
    },
    inactiveRatingChars(): string[] {
      /* Default to ratingChars if no inactive characters have been provided */
      return this.inactiveChar ? Array.from(this.inactiveChar) : this.ratingChars
    },
  },
})
